export const GET_QUICK_PIZZA_ORDERING_API =  'GET_QUICK_PIZZA_ORDERING_API';
export const GET_PIZZA_ORDERING_API =  'GET_PIZZA_ORDERING_API';
